import { IIdentity, AnyFn, TooltipContext, anyFnExec } from '../models';

export function selectTooltipMessage<T extends IIdentity>(
  optionsFn: AnyFn
): (context: TooltipContext<T>) => string {
  return (context) => {
    return anyFnExec(optionsFn, context.data).find(
      (x) => x.id === context.data[context.columnDef]
    )?.name;
  };
}

export function selectSortValueAccessor<T extends IIdentity>(
  optionsFn: AnyFn
): (columnDef: keyof T, data: T) => any {
  return (columnDef, data) =>
    anyFnExec(optionsFn, data).find((x) => x.id === data[columnDef])?.name;
}
